// פונקציה טהורה - לא תלויה ב-window/document/context, בנויה כך שאפשר יהיה להשתמש
// באותה לוגיקה גם מתוך react-helmet בקומפוננטות וגם מתוך סקריפט ה-SSG (build-time, Node).

const daysHeMap = {
    Sunday: "Sunday", Monday: "Monday", Tuesday: "Tuesday", Wednesday: "Wednesday",
    Thursday: "Thursday", Friday: "Friday", Saturday: "Saturday",
    "ראשון": "Sunday", "שני": "Monday", "שלישי": "Tuesday", "רביעי": "Wednesday",
    "חמישי": "Thursday", "שישי": "Friday", "שבת": "Saturday",
};

// seoOpeningHours: [{ Day, Open, Close }] - רק ימים עם ערכים אמיתיים
const buildOpeningHours = (seoOpeningHours) => {
    if (!Array.isArray(seoOpeningHours)) return undefined;

    const specs = seoOpeningHours
        .filter((d) => d && d.Day && d.Open && d.Close)
        .map((d) => ({
            "@type": "OpeningHoursSpecification",
            dayOfWeek: daysHeMap[d.Day] || d.Day,
            opens: d.Open,
            closes: d.Close,
        }));

    return specs.length > 0 ? specs : undefined;
};

// mastercon: אובייקט ה-master מה-DB. מקור האמת היחיד לשדות האלה הוא טאב "קידום SEO"
// באדמין (שדות seo*) - לא נשאב מ-SMSBuiss/EMAILBuiss/socialMds התפעוליים, גם אם יש שם
// ערכים דומים, כדי שיהיה מקום אחד ברור לשליטה על ה-SEO (ראה masterModel.js).
export const buildOrganizationJsonLd = (mastercon, siteUrl) => {
    if (!mastercon) return null;

    const hasAddress = mastercon.seoAddressStreet || mastercon.seoAddressCity || mastercon.seoAddressZip;

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Restaurant",
        name: mastercon.seoBusinessName || mastercon.mainTitle || undefined,
        url: siteUrl || undefined,
        telephone: mastercon.seoPhone || undefined,
        email: mastercon.seoEmail || undefined,
        image: mastercon.seoImage || undefined,
        servesCuisine: mastercon.seoCategory || undefined,
        priceRange: mastercon.seoPriceRange || undefined,
    };

    if (hasAddress) {
        jsonLd.address = {
            "@type": "PostalAddress",
            streetAddress: mastercon.seoAddressStreet || undefined,
            addressLocality: mastercon.seoAddressCity || undefined,
            postalCode: mastercon.seoAddressZip || undefined,
            addressCountry: "IL",
        };
        Object.keys(jsonLd.address).forEach((key) => jsonLd.address[key] === undefined && delete jsonLd.address[key]);
    }

    const openingHours = buildOpeningHours(mastercon.seoOpeningHours);
    if (openingHours) jsonLd.openingHoursSpecification = openingHours;

    const sameAs = [mastercon.seoFacebookUrl, mastercon.seoInstagramUrl, mastercon.seoGoogleMapsUrl].filter(Boolean);
    if (sameAs.length > 0) jsonLd.sameAs = sameAs;

    // מסירים שדות ריקים/undefined - לא ממלאים ברירת מחדל בדויה
    Object.keys(jsonLd).forEach((key) => jsonLd[key] === undefined && delete jsonLd[key]);

    return jsonLd;
};

// pageData: sEOdescription/pageName/mainTitle/addressLine/phoneNum/emailContact - לפי מה שקיים בפועל בעמוד
export const buildWebPageJsonLd = (pageData, pageUrl) => {
    if (!pageData) return null;

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: pageData.pageName || pageData.mainTitle || undefined,
        description: pageData.sEOdescription || undefined,
        url: pageUrl || undefined,
    };

    if (pageData.addressLine || pageData.phoneNum || pageData.emailContact) {
        jsonLd.about = {
            "@type": "LocalBusiness",
            address: pageData.addressLine || undefined,
            telephone: pageData.phoneNum || undefined,
            email: pageData.emailContact || undefined,
        };
        Object.keys(jsonLd.about).forEach((key) => jsonLd.about[key] === undefined && delete jsonLd.about[key]);
    }

    Object.keys(jsonLd).forEach((key) => jsonLd[key] === undefined && delete jsonLd[key]);

    return jsonLd;
};

// product: פריט בודד מתוך buisMenu[].Products (ראה restMenuModel.js) - אין שדה alt ייעודי
// למוצר בסכמה, ולכן נעזרים רק בשדות שקיימים בפועל ולא ממלאים ברירת מחדל בדויה.
export const buildProductJsonLd = (product, pageUrl) => {
    if (!product) return null;

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: product.prodName || undefined,
        description: product.prodSEOdescription || product.prodSmallText || product.prodRemarks || undefined,
        image: product.prodImageUrl || undefined,
        url: pageUrl || undefined,
    };

    if (product.prodPrice != null && product.prodPrice !== "") {
        jsonLd.offers = {
            "@type": "Offer",
            price: product.prodPrice,
            priceCurrency: "ILS",
            availability: product.inStock === false ? "https://schema.org/OutOfStock" : "https://schema.org/InStock",
        };
    }

    Object.keys(jsonLd).forEach((key) => jsonLd[key] === undefined && delete jsonLd[key]);

    return jsonLd;
};

export default { buildOrganizationJsonLd, buildWebPageJsonLd, buildProductJsonLd };
